import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
// Outfit (self-hosted) is the brand face. It has no precomposed Vietnamese letters (ạ, ấ, ở…), so
// Be Vietnam Pro sits next in the font stack: its files are split by unicode-range, so the browser
// only downloads the Vietnamese slice, and only when a page shows one of those letters.
import '@fontsource/outfit/400.css'
import '@fontsource/outfit/500.css'
import '@fontsource/outfit/600.css'
import '@fontsource/outfit/700.css'
import '@fontsource/be-vietnam-pro/400.css'
import '@fontsource/be-vietnam-pro/500.css'
import '@fontsource/be-vietnam-pro/600.css'
import '@fontsource/be-vietnam-pro/700.css'
import '@/styles/globals.css'
// Bio Page attention-effect keyframes, shared with the public page (effect picker previews).
import '@repo/shared/marketing/link-bio-attention-effects.css'
import { ClerkProvider, QueryProvider } from '@/providers'
import { InnerApp } from './inner-app'

function App() {
  return (
    <ClerkProvider>
      <QueryProvider>
        <InnerApp />
        <Toaster
          position="bottom-right"
          containerStyle={{ zIndex: 10000 }}
          toastOptions={{
            duration: 3000,
            style: {
              background: '#333',
              color: '#fff',
              fontSize: '14px',
            },
            success: {
              iconTheme: {
                primary: '#18a058',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </QueryProvider>
    </ClerkProvider>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
